






import { Vue, Component, Model } from "vue-property-decorator";
import { Select } from "ant-design-vue";

@Component({
  name: "SystemFrom",
  components: {
    ASelect: Select,
    ASelectOption: Select.Option
  }
})
export default class SystemFrom extends Vue {
  @Model("input") value!: any;
  private get _value() {
    const _return = this.value;
    return _return ? _return : undefined;
  }

  private dataSource: any = [];

  private created() {
    this.getSystemDict();
  }

  private async getSystemDict() {
    const res = await this.$api.SystemDict("sys_source_system");
    if (res && res.code === 200) {
      this.dataSource = res.data;
    }
  }

  private handleChange(value: string) {
    this.$emit("input", value);
  }
}
